export default "__VITE_ASSET__393ff472__"